import React from 'react';
import Field from '../Field';
import { Form, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';

const AllLawyersDropdown = ({
  width,
  error,
  touched,
  name,
  label,
  value,
  onChange,
  onBlur,
  options,
  fluid,
  search,
  disabled,
  selection,
}) => {
  const undefinedLabel = 'Not Assigned';
  const lawyersComponent = (key, lawyersOptions) =>
  lawyersOptions
    .map(({ text, value, lawFirm }) => {
      if (!text || !value) {
        return null;
      }
      if (lawFirm === key) {
        return {
          key: value,
          text,
          value,
          content: <Dropdown.Item>{text}</Dropdown.Item>
        };
      }
      return null;
    })
    .filter(value => value);

const LawyerGroupedDropdownItems = lawyersOptions => {
  const grouped = _.groupBy(lawyersOptions, option => option.lawFirm) || {};
  const lawFirmKeys = Object.keys(grouped).sort( (a, b) => a > b ? 1 : -1);
  const groupedComponents = lawFirmKeys.map(key => {
    const filteredLawyers = lawyersComponent(key, lawyersOptions);
    if (filteredLawyers && filteredLawyers.length > 0) {
      return [
        <Dropdown.Header
          className={'header header--lawyer'}
          key={key || undefinedLabel}
          style={{ fontWeight: 900 }}
        >
          {key || undefinedLabel}
        </Dropdown.Header>,
        ...filteredLawyers
      ];
    }
    return [];
  });

  return _.flatten(groupedComponents);
};

  return (
  <Field width={width} error={error} touched={touched}>
    <Form.Dropdown
      disabled={disabled}
      fluid={fluid}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      options={LawyerGroupedDropdownItems(options)}
      placeholder={label}
      search={search}
      selection={selection}
      value={value}
    />
  </Field>
)};

export default AllLawyersDropdown;



// WEBPACK FOOTER //
// ./src/component/dropdowns/AllLawyersDropdown.js